export default (that) => [
  {
    exportName: that.$l('INDEX.btn_export_packinglist') || '导出 Packing List',
    templateGroup: 'shipment-invpk',
    exportCheckUrl: '',
  },
  {
    exportName: that.$l('INDEX.btn_export_pendingshippingdetails') || '导出 出运明细',
    templateGroup: 'shipment-pendingshippingdetail',
    exportCheckUrl: '',
  },
]
